(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('.filter-container form');
    const collectionGrid = document.querySelector('.grid'); // Parent container to grid items
    const productCounter = document.querySelector('.counter'); // Container for total count

    // --- Helper: update product counter (enhanced for filtered display) ---
    function updateProductCounter(doc) {
        if (!productCounter) return;

        const newCounter = doc ? doc.querySelector('.counter') : null;
        if (newCounter) {
            productCounter.textContent = newCounter.textContent;
        } else {
            // Use total collection count from data attribute
            const totalCount = collectionGrid ? collectionGrid.dataset.productsCount : 0;
            productCounter.textContent = `Show ${totalCount} results`;
        }
    }

    // --- Helper: update the "Filter (COUNT)" toggle label ---
    function updateFilterToggleCount(doc) {
        const filterToggle = document.querySelector('.filter-toggle');
        const newFilterToggle = doc ? doc.querySelector('.filter-toggle') : null;
        if (filterToggle && newFilterToggle) {
            filterToggle.textContent = newFilterToggle.textContent;
        }
    }


    // --- Handle filter list toggle ---
    const filterListTitles = document.querySelectorAll('.filter-list-title');
    filterListTitles.forEach(title => {
        title.addEventListener('click', function() {
            const filterList = this.closest('.filter-list');
            if (filterList) {
                filterList.classList.toggle('open');
            }
        });
    });

    // --- Handle checkbox changes ---
    const checkboxes = form.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            updateCollection();
        });
    });

    // --- Handle sort by radio button changes ---
    const radioButtons = form.querySelectorAll('input[type="radio"][name="sort_by"]');
    radioButtons.forEach(radio => {
        radio.addEventListener('change', function() {
            updateCollection();
        });
    });

    // --- Handle sort dropdown (external to filter drawer) ---
    const sortSelect = document.getElementById('sort-select');
    if (sortSelect) {
        sortSelect.addEventListener('change', function() {
            // Update the radio buttons in the drawer to match
            radioButtons.forEach(radio => {
                radio.checked = radio.value === this.value;
            });
            
            // Use AJAX update instead of page reload
            updateCollection();
        });
    }

    // --- Handle "Clear All" button ---
    const clearAllBtn = document.querySelector('.clear-all-button');
    if (clearAllBtn) {
        clearAllBtn.addEventListener('click', function() {
            checkboxes.forEach(cb => cb.checked = false);
            
            // Reset sort to default (Featured)
            radioButtons.forEach(radio => {
                if (radio.value === 'manual') {
                    radio.checked = true;
                } else {
                    radio.checked = false;
                }
            });

            // Reset external sort dropdown
            const sortSelect = document.getElementById('sort-select');
            if (sortSelect) {
                sortSelect.value = 'manual';
            }

            if (minSlider && maxSlider) {
                minSlider.value = minSlider.min;
                maxSlider.value = maxSlider.max;
                updateSliderDisplay();
            }

            // Preserve in-stock filter when clearing
            const urlParams = new URLSearchParams(window.location.search);
            const inStockFilter = urlParams.get('filter.v.m.custom.in_stock');
            
            if (inStockFilter) {
                // Build URL with only in-stock filter
                const currentUrl = new URL(window.location);
                const newUrl = new URL(currentUrl.pathname, window.location.origin);
                newUrl.searchParams.set('filter.v.m.custom.in_stock', inStockFilter);
                
                // Navigate to cleared URL with in-stock preserved
                window.location.href = newUrl.toString();
            } else {
                // No in-stock filter, proceed normally
                updateCollection(true);
            }
        });
    }

    // --- Handle "Close" button ---
    const closeFiltersBtns = document.querySelectorAll('.close-filters');
    if (closeFiltersBtns) {
        closeFiltersBtns.forEach(btn => {
            btn.addEventListener('click', function() {
                document.body.classList.remove('filter-drawer-open');
            });
        });
    }

    // --- Handle "Show Results" button ---
    const showResultsBtn = document.querySelector('.show-results-button');
    if (showResultsBtn) {
        showResultsBtn.addEventListener('click', function() {
            document.body.classList.remove('filter-drawer-open');
        });
    }

    // --- Range Slider for Price ---
    const minSlider = document.getElementById('price-min');
    const maxSlider = document.getElementById('price-max');
    const minValueEl = document.getElementById('price-min-value');
    const maxValueEl = document.getElementById('price-max-value');

    // --- Initialize slider from URL parameters ---
    if (minSlider && maxSlider) {
        const urlParams = new URLSearchParams(window.location.search);
        const urlMin = parseFloat(urlParams.get('filter.v.price.gte'));
        const urlMax = parseFloat(urlParams.get('filter.v.price.lte'));

        // Use URL values if present, otherwise defaults from HTML
        const initMin = !isNaN(urlMin) ? urlMin : parseFloat(minSlider.value);
        const initMax = !isNaN(urlMax) ? urlMax : parseFloat(maxSlider.value);

        minSlider.value = initMin;
        maxSlider.value = initMax;

        function formatPrice(value) {
            return `$${parseFloat(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }

        function updateSliderDisplay() {
            let min = parseFloat(minSlider.value);
            let max = parseFloat(maxSlider.value);

            // Prevent crossing
            if (min > max) [min, max] = [max, min];

            minValueEl.textContent = formatPrice(min);
            maxValueEl.textContent = formatPrice(max);
        }

        minSlider.addEventListener('input', updateSliderDisplay);
        maxSlider.addEventListener('input', updateSliderDisplay);

        minSlider.addEventListener('change', updateCollection);
        maxSlider.addEventListener('change', updateCollection);

        // Initial display
        updateSliderDisplay();
    }

    // --- AJAX update (enhanced for collection filtering) ---
    function updateCollection(skipDefaultSlider = false) {
        const formData = new FormData(form);
        const searchParams = new URLSearchParams(formData);

        if (minSlider && maxSlider) {
            let minPrice = Math.min(parseFloat(minSlider.value), parseFloat(maxSlider.value));
            let maxPrice = Math.max(parseFloat(minSlider.value), parseFloat(maxSlider.value));

            if (!skipDefaultSlider || minPrice !== parseFloat(minSlider.min) || maxPrice !== parseFloat(maxSlider.max)) {
                searchParams.set('filter.v.price.gte', minPrice.toFixed(2));
                searchParams.set('filter.v.price.lte', maxPrice.toFixed(2));
            }
        }

        // --- Handle sort dropdown (external to form) ---
        const sortSelect = document.getElementById('sort-select');
        if (sortSelect && sortSelect.value) {
            if (sortSelect.value !== 'manual') {
                searchParams.set('sort_by', sortSelect.value);
            }
        }

        // --- Handle manual sort_by parameter ---
        if (searchParams.get('sort_by') === 'manual') {
          searchParams.delete('sort_by');
        }

        // --- PRESERVE IN-STOCK FILTER ---
        const currentUrlParams = new URLSearchParams(window.location.search);
        const inStockFilter = currentUrlParams.get('filter.v.m.custom.in_stock');
        if (inStockFilter) {
            searchParams.set('filter.v.m.custom.in_stock', inStockFilter);
        }

        const currentUrl = new URL(window.location);
        const newUrl = new URL(currentUrl.pathname, window.location.origin);
        for (const [key, value] of searchParams) {
            newUrl.searchParams.append(key, value);
        }

        fetch(newUrl.toString())
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                // Update collection grid
                const newGrid = doc.querySelector('.grid');
                if (newGrid && collectionGrid) {
                    collectionGrid.innerHTML = newGrid.innerHTML;
                    
                    // Update collection grid data attribute for filter state
                    const newGridContainer = doc.querySelector('#collection-grid');
                    const currentGridContainer = document.querySelector('#collection-grid');
                    if (newGridContainer && currentGridContainer) {
                        currentGridContainer.dataset.hasFilters = newGridContainer.dataset.hasFilters;
                    }
                }

                // Update sentinel for progressive loading
                const newSentinel = doc.querySelector('.pagination-sentinel');
                const currentSentinel = document.querySelector('.pagination-sentinel');
                const statusEl = document.querySelector('.pagination-status');
                
                if (newSentinel && currentSentinel) {
                    currentSentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
                } else if (!newSentinel && currentSentinel) {
                    currentSentinel.remove();
                } else if (newSentinel && !currentSentinel) {
                    // Insert new sentinel
                    const clonedSentinel = newSentinel.cloneNode(true);
                    if (statusEl) {
                        statusEl.parentNode.insertBefore(clonedSentinel, statusEl);
                    } else if (collectionGrid) {
                        collectionGrid.parentNode.appendChild(clonedSentinel);
                    }
                }

                // Notify progressive loader that collection updated
                document.dispatchEvent(new CustomEvent('collection:updated'));

                // Update product counter (this will now handle filtered vs unfiltered counts)
                updateProductCounter(doc);

                // Update the "Filter (COUNT)" toggle label
                updateFilterToggleCount(doc);

                // --- Update pagination ---
                const newPagination = doc.querySelector('.pagination-container');
                const currentPagination = document.querySelector('.pagination-container');
                if (newPagination && currentPagination) {
                    currentPagination.innerHTML = newPagination.innerHTML;

                    // Re-attach click handlers to pagination links
                    const paginationLinks = currentPagination.querySelectorAll('a');
                    paginationLinks.forEach(link => {
                        link.addEventListener('click', function(e) {
                            e.preventDefault();
                            const pageUrl = new URL(link.href);
                            const params = new URLSearchParams(pageUrl.search);
                            // Keep current filter parameters
                            const currentParams = new URLSearchParams(window.location.search);
                            params.forEach((value, key) => currentParams.set(key, value));

                            // Update URL and reload collection via AJAX
                            window.history.pushState({}, '', pageUrl.pathname + '?' + currentParams.toString());
                            updateCollection();
                        });
                    });
                }

                // Update URL without section_id
                window.history.pushState({}, '', newUrl.pathname + newUrl.search.replace('&section_id=collection-template', ''));

                // Update filter states dynamically
                updateFilterStates(doc);

                // Update "Reset filters" button visibility
                updateClearAllButton(doc);
            })
            .catch(error => {
                console.error('Error updating collection:', error);
                // Fallback: reload the page if AJAX fails
                window.location.href = newUrl.toString();
            });
    }

    function updateClearAllButton(doc) {
        const newClearAllBtn = doc ? doc.querySelector('.clear-all-button') : null;
        const currentClearAllBtn = document.querySelector('.clear-all-button');
        const formButtons = document.querySelector('.form-buttons');

        if (newClearAllBtn && !currentClearAllBtn) {
            // Button should exist but doesn't - add it
            formButtons.appendChild(newClearAllBtn.cloneNode(true));
            // Re-attach event listener
            attachClearAllListener();
        } else if (!newClearAllBtn && currentClearAllBtn) {
            // Button should not exist but does - remove it
            currentClearAllBtn.remove();
        }
    }

    function attachClearAllListener() {
        const clearAllBtn = document.querySelector('.clear-all-button');
        if (clearAllBtn) {
            clearAllBtn.addEventListener('click', function() {
                checkboxes.forEach(cb => cb.checked = false);
                
                // Reset sort to default (Featured)
                radioButtons.forEach(radio => {
                    if (radio.value === 'manual') {
                        radio.checked = true;
                    } else {
                        radio.checked = false;
                    }
                });

                // Reset external sort dropdown
                const sortSelect = document.getElementById('sort-select');
                if (sortSelect) {
                    sortSelect.value = 'manual';
                }

                if (minSlider && maxSlider) {
                    minSlider.value = minSlider.min;
                    maxSlider.value = maxSlider.max;
                    updateSliderDisplay();
                }

                // Preserve in-stock filter when clearing
                const urlParams = new URLSearchParams(window.location.search);
                const inStockFilter = urlParams.get('filter.v.m.custom.in_stock');
                
                if (inStockFilter) {
                    // Build URL with only in-stock filter
                    const currentUrl = new URL(window.location);
                    const newUrl = new URL(currentUrl.pathname, window.location.origin);
                    newUrl.searchParams.set('filter.v.m.custom.in_stock', inStockFilter);
                    
                    // Navigate to cleared URL with in-stock preserved
                    window.location.href = newUrl.toString();
                } else {
                    // No in-stock filter, proceed normally
                    updateCollection(true);
                }
            });
        }
    }

    function updateFilterStates(doc) {
        const newFilterContainer = doc.querySelector('.filter-container');
        if (!newFilterContainer) return;

        const newCheckboxes = newFilterContainer.querySelectorAll('input[type="checkbox"]');
        newCheckboxes.forEach((newCheckbox) => {
            // Find matching checkbox by id instead of index
            const currentCheckbox = form.querySelector(`input[id="${newCheckbox.id}"]`);
            if (currentCheckbox && newCheckbox) {
                currentCheckbox.disabled = newCheckbox.disabled;
                
                // Update the entire label content including swatches and counts
                const currentLabel = currentCheckbox.closest('label');
                const newLabel = newCheckbox.closest('label');
                if (currentLabel && newLabel) {
                    // Update label class to match new state
                    if (newLabel.classList.contains('filter-unavailable')) {
                        currentLabel.classList.add('filter-unavailable');
                    } else {
                        currentLabel.classList.remove('filter-unavailable');
                    }
                    
                    // Keep the input element but replace everything else
                    const currentInput = currentLabel.querySelector('input');
                    currentLabel.innerHTML = newLabel.innerHTML;
                    // Replace the input with the original one to maintain event listeners
                    const newInput = currentLabel.querySelector('input');
                    if (newInput && currentInput) {
                        newInput.replaceWith(currentInput);
                        currentInput.disabled = newCheckbox.disabled;
                    }
                }
                
                // Also update li class for consistency
                const currentLi = currentCheckbox.closest('li');
                if (currentLi) {
                    if (newCheckbox.disabled) {
                        currentLi.classList.add('filter-unavailable');
                    } else {
                        currentLi.classList.remove('filter-unavailable');
                    }
                }
            }
        });

        // Update radio button states for sort by (these should maintain order)
        const newRadioButtons = newFilterContainer.querySelectorAll('input[type="radio"][name="sort_by"]');
        newRadioButtons.forEach((newRadio) => {
            const currentRadio = form.querySelector(`input[id="${newRadio.id}"]`);
            if (currentRadio && newRadio) {
                currentRadio.checked = newRadio.checked;
                
                // Update external sort dropdown to match
                const sortSelect = document.getElementById('sort-select');
                if (sortSelect && newRadio.checked) {
                    sortSelect.value = newRadio.value;
                }
            }
        });
    }

    // --- Initial page load ---
    updateProductCounter();
});
  } catch(e) { console.error(e); }
})();

})();
